'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var compare = {
  eq: function eq(left, right) {
    return !compare.ne(left, right);
  },
  ne: function ne(left, right) {
    var i = void 0,
        len = void 0,
        res = void 0;
    for (i = 0, len = Math.max(left.length, right.length); i < len; i++) {
      res = (+left[i] || 0) - (+right[i] || 0);
      if (res !== 0) {
        return true;
      }
    }
    return false;
  },
  gt: function gt(left, right) {
    var i = void 0;
    var len = void 0;
    var res = void 0;
    for (i = 0, len = Math.max(left.length, right.length); i < len; i++) {
      res = (+left[i] || 0) - (+right[i] || 0);
      if (res > 0) {
        return true;
      } else if (res < 0) {
        return false;
      }
    }
    return false;
  },
  lt: function lt(left, right) {
    return compare.gt(right, left);
  },
  gte: function gte(left, right) {
    return !compare.lt(left, right);
  },
  lte: function lte(left, right) {
    return !compare.gt(left, right);
  }
};

var get = function get() {
  try {
    if (/Maizuo/.test(window.navigator.userAgent)) {
      return navigator.userAgent.match(/(Maizuo)\/(\d*(\.\d*)*)/i)[2];
    }
    return navigator.userAgent.match(/(MZMall)\/(\d*(\.\d*)*)/i)[2];
  } catch (e) {
    return '';
  }
};
exports.default = {
  compare: compare,
  get: get
};